import { useEffect, useState } from 'react';

// Renders a live "2d 05h 32m" countdown to a server-provided target date —
// never a hardcoded/derived frontend date (early.txt section 8). Recomputes
// every minute; parent should stop rendering this once the target passes.
function formatRemaining(ms) {
  if (ms <= 0) return null;
  const totalMinutes = Math.floor(ms / 60000);
  const days = Math.floor(totalMinutes / (60 * 24));
  const hours = Math.floor((totalMinutes % (60 * 24)) / 60);
  const minutes = totalMinutes % 60;
  return `${days}d ${String(hours).padStart(2, '0')}h ${String(minutes).padStart(2, '0')}m`;
}

export default function Countdown({ target, className, onComplete }) {
  const targetMs = target ? new Date(target).getTime() : null;
  const [remaining, setRemaining] = useState(() => (targetMs ? targetMs - Date.now() : null));

  useEffect(() => {
    if (!targetMs) return;
    setRemaining(targetMs - Date.now());
    const id = setInterval(() => {
      setRemaining((prev) => {
        const next = targetMs - Date.now();
        if (next <= 0) {
          clearInterval(id);
          onComplete?.();
        }
        return next;
      });
    }, 60000);
    return () => clearInterval(id);
  }, [targetMs]);

  if (!targetMs || remaining === null) return null;
  const label = formatRemaining(remaining);
  if (!label) return null;

  return <span className={className}>{label}</span>;
}
